import Profile from 'models/Profile';

type ClientProviderTypes<T extends { id: string }> = { managedProviderTypes: T[]; providedProviderTypes: T[] };

// The provider types a client's lists can hold: the types it manages but doesn't provide itself.
// Mirrors PreferredProvider::Selectable on the API, which is what actually enforces it.
export const selectableProviderTypesFor = <T extends { id: string }>(client: ClientProviderTypes<T>) => {
  const providedIds = new Set(client.providedProviderTypes.map((type) => type.id));

  return client.managedProviderTypes.filter((type) => !providedIds.has(type.id));
};

export const selectablePreferredProviderTypes = (profile: Profile) => selectableProviderTypesFor(profile.actingClient);
